import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { ShoppingBag, User, Search, LogOut } from "lucide-react";
import { useCart } from "../context/CartContext";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

const LOGO = "https://customer-assets.emergentagent.com/job_f80e39fa-3ab4-4fff-9ec3-40cb3c2b407a/artifacts/imxdvq2l_ChatGPT%20Image%20May%2023%2C%202026%2C%2012_15_06%20PM.png";

export default function Navbar() {
  const { count } = useCart();
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = () => {
    logout();
    toast.success("LOGGED OUT");
    navigate("/");
  };

  return (
    <header className="sticky top-0 z-50 backdrop-blur-md bg-black/80 border-b border-[#27272A]" data-testid="store-navbar">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 h-16 flex items-center justify-between">
        <div className="flex items-center gap-8">
          <Link to="/" className="flex items-center gap-2" data-testid="logo-home-link">
            <img src={LOGO} alt="Cult Lyf" className="h-9 w-9 object-contain" />
            <span className="font-display font-black text-lg tracking-tight hidden sm:inline">CULT LYF</span>
          </Link>
          <nav className="hidden md:flex items-center gap-6 label-mono text-white">
            <NavLink to="/shop" end className="nav-link" data-testid="nav-shop">Shop</NavLink>
            <NavLink to="/shop?category=clothing" className="nav-link" data-testid="nav-clothing">Clothing</NavLink>
            <NavLink to="/shop?category=shoes" className="nav-link flex items-center gap-1" data-testid="nav-shoes">
              Shoes <span className="text-[9px] text-[#CFF048] tracking-widest">SOON</span>
            </NavLink>
            <NavLink to="/shop?category=caps" className="nav-link flex items-center gap-1" data-testid="nav-caps">
              Caps <span className="text-[9px] text-[#CFF048] tracking-widest">SOON</span>
            </NavLink>
            <NavLink to="/community" className="nav-link" data-testid="nav-community">Community</NavLink>
            <NavLink to="/bulk" className="nav-link" data-testid="nav-bulk">Bulk</NavLink>
          </nav>
        </div>
        <div className="flex items-center gap-4 text-white">
          <button className="hidden sm:flex items-center justify-center w-9 h-9 hover:text-[#CFF048] transition-colors" data-testid="search-btn">
            <Search size={18} />
          </button>
          {user ? (
            <>
              <Link to={user.role === "admin" ? "/admin" : "/account/orders"} className="flex items-center gap-2 hover:text-[#CFF048] transition-colors" data-testid="account-link">
                <User size={18} />
                <span className="label-mono hidden sm:inline">{user.name?.split(" ")[0]}</span>
              </Link>
              <button
                onClick={doLogout}
                className="flex items-center gap-1 label-mono hover:text-[#CFF048] transition-colors"
                title="Logout"
                data-testid="logout-btn"
              >
                <LogOut size={16} />
                <span className="hidden sm:inline">LOGOUT</span>
              </button>
            </>
          ) : (
            <Link to="/login" className="label-mono hover:text-[#CFF048] transition-colors" data-testid="login-link">Login</Link>
          )}
          <Link to="/cart" className="relative flex items-center" data-testid="cart-link">
            <ShoppingBag size={20} />
            {count > 0 && (
              <span className="absolute -top-2 -right-2 bg-[#CFF048] text-black text-[10px] font-bold w-4 h-4 flex items-center justify-center rounded-full">
                {count}
              </span>
            )}
          </Link>
        </div>
      </div>
    </header>
  );
}
